import { useContentLanguage } from "./content-language-context"
import { ContentLanguageItem } from "./content-language-item"
import { removeContentLanguage } from "./controller/remove-content-language"
import { hasDemand } from "lib/authorization/has-demand"
import { confirm } from "lib/@dialogs/confirm"

export function LanguageOption({ item, onClose }) {
    const { language, setLanguage } = useContentLanguage()
    const isAdmin = hasDemand("sfg20Admin")

    return (
        <ContentLanguageItem
            item={item}
            selected={language === item.code}
            onSelect={handleSelect}
            onDelete={isAdmin ? handleDelete : undefined}
        />
    )

    function handleSelect(lang) {
        setLanguage(lang.code, lang.rtl, lang.name)
        onClose()
    }

    async function handleDelete(lang) {
        const ok = await confirm(`Remove ${lang.name}?`, "Remove Language")
        if (!ok) return
        if (language === lang.code) {
            setLanguage("en", false, "English")
        }
        await removeContentLanguage({ code: lang.code })
        onClose()
    }
}
